<div class="palette">
  <h3 class="palette-title">Add node</h3>
  @for (group of groups; track group.label) {
    <div class="palette-group">
      <span class="palette-group-label">{{ group.label }}</span>
      @for (item of group.items; track item.label) {
        <button type="button" class="palette-item" (click)="onAdd(item)">
          <span class="material-symbols-outlined palette-item-icon">{{ item.icon }}</span>
          <span class="palette-item-label">{{ item.label }}</span>
        </button>
      }
    </div>
  }
</div>
